import '../scss/styles.scss';

(function ($) {
    $(document).ready(function () {

        const animateInfographicSections = function () {
            const sections = Array.prototype.slice.call(document.querySelectorAll('body.InfographicPage main section'));
            const headings = Array.prototype.slice.call(document.querySelectorAll('body.InfographicPage main .red-left-border'));

            if (!sections.length) {
                return;
            }

            const run = function () {
                const gsap = window.gsap;
                const ScrollTrigger = window.ScrollTrigger;

                if (!gsap || !ScrollTrigger) {
                    return false;
                }

                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                    gsap.set(sections, {autoAlpha: 1, y: 0});
                    gsap.set(headings, {'--red-left-border-height': '10rem'});
                    return true;
                }

                gsap.registerPlugin(ScrollTrigger);
                gsap.set(headings, {'--red-left-border-height': '0rem'});

                sections.forEach(function (section) {
                    const sectionHeadings = Array.prototype.slice.call(section.querySelectorAll('.red-left-border'));
                    const animateSectionHeadings = function () {
                        if (!sectionHeadings.length) {
                            return;
                        }

                        gsap.to(sectionHeadings, {
                            '--red-left-border-height': '10rem',
                            duration: 0.8,
                            ease: 'power2.out'
                        });
                    };

                    gsap.fromTo(section, {
                        autoAlpha: 0,
                        y: 100
                    }, {
                        autoAlpha: 1,
                        duration: 1,
                        ease: 'power2.out',
                        scrollTrigger: {
                            trigger: section,
                            start: 'top 85%',
                            once: true,
                            onEnter: function () {
                                gsap.delayedCall(0.75, animateSectionHeadings);
                            }
                        },
                        y: 0
                    });
                });

                return true;
            };

            if (run()) {
                return;
            }

            window.addEventListener('load', run, {once: true});
        };

        const infographicAccordionSelector = 'section.infographic__accordions';
        const infographicAccordionStopProperties = [
            ['--accordion-gradient-stop-1-top', '--accordion-gradient-stop-1-bottom'],
            ['--accordion-gradient-stop-2-top', '--accordion-gradient-stop-2-bottom'],
            ['--accordion-gradient-stop-3-top', '--accordion-gradient-stop-3-bottom']
        ];

        const getInfographicAccordionSection = function ($btn) {
            return $btn.closest(infographicAccordionSelector)[0];
        };

        const addInfographicAccordionGradientDebugMarkers = function (section) {
            if (section.querySelector('.infographic__accordions__gradient-debug')) {
                return;
            }

            infographicAccordionStopProperties.forEach(function (properties) {
                properties.forEach(function (property, index) {
                    const marker = document.createElement('div');
                    marker.className = 'infographic__accordions__gradient-debug';
                    if (index === 1) {
                        marker.classList.add('infographic__accordions__gradient-debug--bottom');
                    }
                    marker.style.setProperty('--accordion-gradient-debug-stop', 'var(' + property + ')');
                    marker.setAttribute('aria-hidden', 'true');
                    section.appendChild(marker);
                });
            });
        };

        const getPercentageFromSectionTop = function (sectionRect, offset) {
            return Math.max(0, Math.min(100, (offset / sectionRect.height) * 100)).toFixed(2) + '%';
        };

        const updateInfographicAccordionGradient = function (section) {
            if (!section) {
                return;
            }

            if (section.classList.contains('debug')) {
                section.classList.remove('debug');
                addInfographicAccordionGradientDebugMarkers(section);
            }

            const accordions = Array.prototype.slice.call(section.querySelectorAll(':scope > .infographic__accordions__inner > .infographic__accordions__accordion'));
            const sectionRect = section.getBoundingClientRect();

            if (!accordions.length || !sectionRect.height) {
                return;
            }

            accordions.forEach(function (accordion, index) {
                const properties = infographicAccordionStopProperties[index];

                if (!properties) {
                    return;
                }

                const accordionRect = accordion.getBoundingClientRect();
                const topOffset = accordionRect.top - sectionRect.top + (index > 0 ? 30 : 0);
                const top = getPercentageFromSectionTop(sectionRect, topOffset);
                const bottom = getPercentageFromSectionTop(sectionRect, accordionRect.bottom - sectionRect.top);

                section.style.setProperty(properties[0], top);
                section.style.setProperty(properties[1], bottom);
            });
        };

        const updateAllInfographicAccordionGradients = function () {
            Array.prototype.forEach.call(document.querySelectorAll(infographicAccordionSelector), updateInfographicAccordionGradient);
        };

        const matchKeyActivityHeights = function () {
            const activities = Array.prototype.slice.call(document.querySelectorAll('.key-activities__grid__activity'));

            if (!activities.length) {
                return;
            }

            activities.forEach(function (activity) {
                activity.style.height = '';
            });

            const tallest = activities.reduce(function (height, activity) {
                return Math.max(height, activity.getBoundingClientRect().height);
            }, 0);

            activities.forEach(function (activity) {
                activity.style.height = tallest + 'px';
            });
        };

        const openAccordion = function ($btn) {
            const $panel = $('#' + $btn.attr('aria-controls'));
            const section = getInfographicAccordionSection($btn);
            const updateGradient = function () {
                updateInfographicAccordionGradient(section);
            };

            $btn.addClass('open').attr('aria-expanded', 'true');
            $panel.attr('aria-hidden', 'false').slideDown({
                progress: updateGradient,
                complete: updateGradient
            });
        };

        const closeAccordion = function ($btn) {
            const $panel = $('#' + $btn.attr('aria-controls'));
            const section = getInfographicAccordionSection($btn);
            const updateGradient = function () {
                updateInfographicAccordionGradient(section);
            };

            $btn.removeClass('open').removeAttr('aria-expanded');
            $panel.attr('aria-hidden', 'true').slideUp({
                progress: updateGradient,
                complete: updateGradient
            });
        };

        const afterScroll = function (callback) {
            let animationFrame;
            let fallback;
            let lastScrollY = window.scrollY;
            let stableFrames = 0;
            let complete = false;

            const done = function () {
                if (complete) {
                    return;
                }

                complete = true;
                window.removeEventListener('scrollend', done);
                cancelAnimationFrame(animationFrame);
                clearTimeout(fallback);
                callback();
            };

            const checkScroll = function () {
                const currentScrollY = window.scrollY;

                if (currentScrollY === lastScrollY) {
                    stableFrames += 1;
                } else {
                    stableFrames = 0;
                    lastScrollY = currentScrollY;
                }

                if (stableFrames >= 2) {
                    done();
                    return;
                }

                animationFrame = requestAnimationFrame(checkScroll);
            };

            window.addEventListener('scrollend', done, {once: true});
            animationFrame = requestAnimationFrame(checkScroll);
            fallback = setTimeout(done, 900);
        };

        $('.infographic__accordions__accordion button').on('click', function () {
            const $btn = $(this);
            if ($btn.hasClass('open')) {
                closeAccordion($btn);
            } else {
                openAccordion($btn);
            }
        });

        $('.key-activities__grid__activity').on('click', function (event) {
            const hash = this.hash;
            const $target = $(hash);
            const $btn = $target.children('button');

            if (!$target.length || !$btn.length) {
                return;
            }

            event.preventDefault();

            const openTarget = function () {
                window.history.pushState(null, '', hash);
                $btn.trigger('focus');

                if (!$btn.hasClass('open')) {
                    openAccordion($btn);
                }
            };

            $target[0].scrollIntoView({behavior: 'smooth'});
            afterScroll(openTarget);
        });

        updateAllInfographicAccordionGradients();
        matchKeyActivityHeights();
        $(window).on('load resize', updateAllInfographicAccordionGradients);
        $(window).on('load resize', matchKeyActivityHeights);

        animateInfographicSections();

    });
})(jQuery);
